import {
  getRangeMinutes,
  timeCompare,
} from "../components/SpaceReservation/TimeSlots";
import {
  AvailableDays,
  Reservation,
  SpaceReservationItem,
} from "../services/spaceReservationServices";
import { isNumber } from "./common";
import { getHourMinString } from "./dateFormat";
import { convertToKoreanNumber } from "./numberFormat";

export const isNotNull = (value: any) => {
  return value !== null && value !== undefined && value !== "";
};

export const makeSpaceDefaultPrice = (
  detail: Partial<SpaceReservationItem>,
  reservation: Partial<Reservation>,
  isBold: boolean = true
) => {
  let price = 0;
  let totalSpacePriceText: React.ReactNode = "";
  let totalSpaceHourText = "";
  let priceStyle = isBold
    ? "flex flex-col text-base font-semibold leading-[26px]"
    : "flex flex-col";

  if (detail.usePayment === true) {
    if (
      detail.usableTimeStart &&
      detail.usableTimeEnd &&
      isNumber(detail.defaultPrice) &&
      isNumber(detail.additionalPrice) &&
      detail.defaultPriceTimeStart &&
      detail.defaultPriceTimeEnd &&
      detail.defaultPriceDays &&
      isNotNull(reservation.reservationDate) &&
      isNotNull(reservation.reservationTimeStart) &&
      isNotNull(reservation.reservationTimeEnd) &&
      reservation.reservationDate &&
      reservation.reservationTimeStart &&
      reservation.reservationTimeEnd
    ) {
      const range = getRangeMinutes(
        reservation.reservationTimeStart,
        reservation.reservationTimeEnd
      );

      const daysOfWeek: (keyof AvailableDays)[] = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ];

      const day = new Date(reservation.reservationDate).getDay();

      // 정가요일 여부. 정가요일이 아닌 경우 할증요금으로 계산.
      const isDefaultPriceDay = detail.defaultPriceDays[daysOfWeek[day]];

      if (
        // 할증 시간이 포함되어있지 않을때
        isDefaultPriceDay &&
        timeCompare(
          reservation.reservationTimeStart,
          detail.defaultPriceTimeStart,
          true
        ) === true &&
        timeCompare(
          detail.defaultPriceTimeEnd,
          reservation.reservationTimeEnd,
          true
        ) === true
      ) {
        // console.log("할증시간 포암 안되어있음");
        if (range > detail.usableTimeEnd) {
          //추가 요름 필요
          price =
            detail.usableTimeEnd * detail.defaultPrice +
            (range - detail.usableTimeEnd) * detail.additionalPrice;
        } else {
          price = range * detail.defaultPrice;
        }

        price = price / 30;

        totalSpacePriceText = `${convertToKoreanNumber(price)}원`;
        totalSpaceHourText = `${getHourMinString(range)}`;
      } else {
        let overchargeLeft = 0;
        let overchargeRight = 0;
        let overchargeTotal = 0;

        // 측정 시간 전체가 할증 시간에 포함될때
        if (
          !isDefaultPriceDay ||
          timeCompare(
            reservation.reservationTimeStart,
            detail.defaultPriceTimeEnd,
            true
          ) ||
          timeCompare(
            detail.defaultPriceTimeStart,
            reservation.reservationTimeEnd,
            true
          )
        ) {
          // console.log("전체 영역이 할증요금 구간");
          //range만금 할증 과금
          if (range > detail.usableTimeEnd) {
            //추가 요금 필요
            price =
              (detail.usableTimeEnd * detail.defaultPrice +
                (range - detail.usableTimeEnd) * detail.additionalPrice) *
              1.2;
            overchargeTotal = price;
          } else {
            price = range * detail.defaultPrice * 1.2;
            overchargeTotal = price;
          }

          price = price / 30;
          overchargeTotal = overchargeTotal / 30;

          totalSpacePriceText = (
            <div className="flex flex-row items-center flex-wrap">
              <div className={priceStyle}>{convertToKoreanNumber(price)}</div>
              원&nbsp;
              <div className="flex flex-col text-sm text-gray-600">
                (할증 {convertToKoreanNumber(overchargeTotal)}원 포함)
              </div>
            </div>
          );
          totalSpaceHourText = `${getHourMinString(
            range
          )} (할증 ${getHourMinString(range)})`;
        } else {
          // console.log("전체 영역이 할증요금 구간 아님");
          if (
            timeCompare(
              reservation.reservationTimeStart,
              detail.defaultPriceTimeStart
            ) === false
          ) {
            overchargeLeft = getRangeMinutes(
              reservation.reservationTimeStart,
              detail.defaultPriceTimeStart
            );
          }

          if (
            timeCompare(
              detail.defaultPriceTimeEnd,
              reservation.reservationTimeEnd
            ) === false
          ) {
            overchargeRight = getRangeMinutes(
              detail.defaultPriceTimeEnd,
              reservation.reservationTimeEnd
            );
          }

          /*console.log(
            "최종 과금 : ",
            overchargeLeft,
            overchargeRight,
            range,
            detail.usableTimeEnd
          );*/

          //과금 포함된 전체 시간이 사용시간 초과했을때
          if (overchargeLeft + range + overchargeRight > detail.usableTimeEnd) {
            if (overchargeLeft >= detail.usableTimeEnd) {
              //앞쪽 과금이 허용시간 초과했을때

              //기본 시간까지 기본요금 하고 이후시간 전부 추가요금
              price =
                detail.usableTimeEnd * detail.defaultPrice * 1.2 +
                (overchargeLeft - detail.usableTimeEnd) *
                  detail.additionalPrice *
                  1.2;

              overchargeTotal = price;

              // 할증 + 정상시간인 경우
              if (overchargeRight > 0) {
                if (range - overchargeLeft - overchargeRight > 0) {
                  price +=
                    (range - overchargeLeft - overchargeRight) *
                    detail.additionalPrice;
                }

                price += overchargeRight * detail.additionalPrice * 1.2;

                overchargeTotal +=
                  overchargeRight * detail.additionalPrice * 1.2;
              } else {
                if (range - overchargeLeft > 0) {
                  price += (range - overchargeLeft) * detail.additionalPrice;
                }
              }
            } else {
              // 앞쪽 과금이 허용시간 내
              price = overchargeLeft * detail.defaultPrice * 1.2;

              overchargeTotal = price;
              // 남은 허용 가능 시간보다 요청한 사용시간이 클때
              if (detail.usableTimeEnd - overchargeLeft < range) {
                price +=
                  (detail.usableTimeEnd - overchargeLeft) *
                    detail.defaultPrice +
                  (range - detail.usableTimeEnd - overchargeRight) *
                    detail.additionalPrice +
                  price +
                  overchargeRight * detail.additionalPrice * 1.2;

                overchargeTotal +=
                  overchargeRight * detail.additionalPrice * 1.2;
              } else {
                price += range * detail.defaultPrice;
                // 남은 허용 가능 시간 보다 추가 할증 시간이 클때
                if (
                  detail.usableTimeEnd - overchargeLeft - range <
                  overchargeRight
                ) {
                  price +=
                    (detail.usableTimeEnd - overchargeLeft - range) *
                      detail.defaultPrice *
                      1.2 +
                    (overchargeRight -
                      (detail.usableTimeEnd - overchargeLeft - range)) *
                      detail.additionalPrice *
                      1.2;

                  overchargeTotal +=
                    ((detail.usableTimeEnd - overchargeLeft - range) *
                      detail.defaultPrice *
                      1.2 +
                      (overchargeRight -
                        (detail.usableTimeEnd - overchargeLeft - range)) *
                        detail.additionalPrice *
                        1.2) /
                    30;
                } else {
                  price += overchargeRight * detail.defaultPrice * 1.2;

                  overchargeTotal += price;
                }
              }
            }

            price = Math.floor(Number(price / 30));
            overchargeTotal = Math.floor(Number(overchargeTotal / 30));
            totalSpacePriceText = (
              <div className="flex flex-row items-center flex-wrap">
                <div className={priceStyle}>{convertToKoreanNumber(price)}</div>
                원&nbsp;
                <div className="flex flex-col text-sm text-gray-600">
                  (할증 {convertToKoreanNumber(overchargeTotal)}원 포함)
                </div>
              </div>
            );
            totalSpaceHourText = `${getHourMinString(
              range
            )} (할증 ${getHourMinString(overchargeLeft + overchargeRight)})`;
          } else {
            price = Math.floor(Number((range * detail.defaultPrice) / 30));

            totalSpacePriceText = `${convertToKoreanNumber(price)}원`;

            totalSpaceHourText = getHourMinString(range);
          }
        }
      }
    }
  }

  return {
    totalSpacePriceText,
    totalSpaceHourText,
    totalSpaceDefaultPrice: Math.round(price),
  };
};
